<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Master Budget Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col md="8">
                            <b-input-group>
                                <b-input-group-prepend><label>Master Budget No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomor" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input>
                                <b-input-group-prepend><span class="p-2">Budget Date</span></b-input-group-prepend>
                                <b-form-input v-model="model.tanggal" type="date"  :state="!$v.model.tanggal.$error"></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                        <b-col md="4">
                            <b-input-group v-if="(!(model.pjxhdrkey))">
                                <b-input-group-prepend><label>Copy from Budget#</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomorcopy" readonly></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuBudgetShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row >  
                    <b-row>
                        <b-col md="9">
                            <b-input-group >
                                <b-input-group-prepend><label>Budget Name</label></b-input-group-prepend>
                                <b-form-input v-model="model.uraian"  placeholder="Name/Description" :state="!$v.model.uraian.$error"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-checkbox value="1" unchecked-value="0" v-model="model.sales"  class="mt-1">Budget Sales/Project</b-form-checkbox>
                        </b-col>
                    </b-row>    

                    <b-row v-if="(model.sales=='1')">
                        <b-col md="7">
                            <b-input-group >
                                <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.custinfo" :state="!$v.model.cust_id.$error"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuCustomerShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col md="5">
                            <b-input-group >
                                <b-input-group-prepend><label>Customer Order No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.cust_po" placeholder="Customer Order No."></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>    
                    <b-row no-gutters>
                        <!-- <b-col md="4">
                            <b-input-group>
                                <b-input-group-prepend><label>Jumlah Produksi</label></b-input-group-prepend>
                                <b-form-input v-model="model.jmlproduksi" type="number" :state="!$v.model.jmlproduksi.$error"  @change="produksiChange"></b-form-input>
                                <b-input-group-prepend><span class="input-group-text">kali</span></b-input-group-prepend>
                            </b-input-group>
                        </b-col> -->
                        <!-- <b-col md="8">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Nomor Produksi.</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomorproduksi" :state="!$v.model.nomorproduksi.$error" placeholder="comma separated" readonly></b-form-input>
                                <b-input-group-append v-if="saveEnabled">
                                <b-btn text="Button" @click="showFormProduksi=true" >
                                    <i class="fa fa-pencil"></i> edit
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col> -->
                        <b-col md="7">
                            <b-input-group>
                                <b-input-group-prepend><label>Jumlah Produksi</label></b-input-group-prepend>
                                <b-form-input v-model="model.jmlproduksi" type="number" :state="!$v.model.jmlproduksi.$error"  @change="produksiChange"></b-form-input>
                                <b-input-group-prepend><span class="input-group-text">kali</span></b-input-group-prepend>
                                <b-input-group-prepend><span class="ml-2 mr-1 pt-2">Awal No.Produksi</span></b-input-group-prepend>
                                <b-form-input v-model="model.noawalproduksi" :state="!$v.model.noawalproduksi.$error" @change="produksiChange" type="number" ></b-form-input>
                                <!-- <b-input-group-append >
                                    <b-dropdown  dropright  toggle-class="text-decoration-none" no-caret v-b-tooltip.hover title="find Last Number">
                                        <template v-slot:button-content>
                                            <i class="fa fa-search-plus text-success"></i>
                                        </template>
                                        <b-dropdown-item v-for="(row, idx) in dimension" :key="idx" @click="findLastEps(row)"> by {{row.text}}</b-dropdown-item>
                                    </b-dropdown>
                                </b-input-group-append> -->
                            </b-input-group>
                        </b-col>
                        <b-col md="5">                            
                            <b-input-group>
                                <b-form-input v-model="model.nomorproduksi" :state="!$v.model.nomorproduksi.$error" class="ml-1"  readonly></b-form-input>
                                <b-input-group-append >
                                    <b-btn text="Button" @click="showFormProduksi=true" > <i class="fa fa-ellipsis-h"></i> </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row >  
                    <b-row>
                        <b-col md="7">
                            <b-input-group >
                                    <b-input-group-prepend><label >Periode Produksi</label></b-input-group-prepend>
                                    <!-- <b-form-input v-model="model.startdate" type="date" @change="updateTgl2" :state="!$v.model.startdate.$error"></b-form-input>
                                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                                    <b-form-input v-model="model.finishdate" type="date" @change="updateTgl1" :state="!$v.model.finishdate.$error"></b-form-input> -->
                                    <b-form-input v-model="model.startdate" type="date"  :state="!$v.model.startdate.$error"></b-form-input>
                                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                                    <b-form-input v-model="model.finishdate" type="date"  :state="!$v.model.finishdate.$error"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="5">
                            <b-input-group>
                                <b-input-group-prepend><label>Lokasi Produksi</label></b-input-group-prepend>
                                <b-form-input v-model="model.lokasi"  ></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>    

                </b-col>
                <b-col md="4">
                    <v-dim :model="model" :key="updateDimHdr"></v-dim>
                </b-col>
              </b-row>
              <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblOrdLines"
                    outlined
                    striped hover small
                    style="font-size:smaller;"
                    :items="ordLines.items"
                    :fields="ordLines.fields"
                    :current-page="ordLines.page"
                    :per-page="ordLines.limit"
                    >
                        <!-- <template v-slot:cell(itemno)="data">
                        {{data.itemno}}
                        </template> -->
                        <template v-slot:cell(quantity)="data">
                            {{data.item.quantity|numFormat}}
                        </template>
                        <template v-slot:cell(repetit_qty)="data">
                            <span v-if="(data.item.repetit_qty)">{{data.item.repetit_qty}} | {{data.item.repetit_nm}}</span>                            
                        </template>
                        <template v-slot:cell(unitprice)="data">
                            <span v-if="(data.item.unitprice)">{{uanguser}} {{data.item.unitprice|numFormat}}</span>
                        </template>
                        <template v-slot:cell(budgetamt)="data">
                            <span v-if="(data.item.unitprice)">{{uanguser}} {{data.item.budgetamt|numFormat}}</span>                        
                        </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editOrdLines(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delOrdLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                    <template v-slot:row-details="row">
                    <b-card class="row-details-form">
                            <b-row h-align="center">
                                <b-col md="7" >
                                    <b-input-group>
                                        <b-input-group-prepend><label>Costing Item</label></b-input-group-prepend>
                                        <b-form-input readonly v-model="ordLinesObj.iteminfo" :state="!$v.ordLinesObj.jccostkey.$error"></b-form-input>
                                        <b-input-group-append>
                                        <b-btn text="Button" @click="lkuItemShow=true" id="glAccount">
                                            <i class="fa fa-search"></i>
                                        </b-btn>
                                        </b-input-group-append>
                                        <b-form-checkbox v-model="ordLinesObj.noncash" :value="1" :unchecked-value="0"  class="pt-2">Non CASH</b-form-checkbox>
                                    </b-input-group>
                                    <b-row no-gutters>
                                        <b-col md="6">
                                            <b-input-group>
                                                <b-input-group-prepend><label>Quantity</label></b-input-group-prepend>
                                                <b-form-input v-model="ordLinesObj.quantity" @change="calcPrice()" type="number" ></b-form-input>
                                                <b-form-input v-model="ordLinesObj.unitsize" class="ml-1" readonly ></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Unit price</label></b-input-group-prepend>
                                                <b-input-group-prepend><span class="input-group-text">{{uanguser}}</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.unitprice" :precision="2" :state="!$v.ordLinesObj.unitprice.$error"></my-number>
                                            </b-input-group>
                                        </b-col>
                                    </b-row >                      
                                    <b-row no-gutters>
                                        <b-col md="6">
                                            <b-input-group>
                                                <b-input-group-prepend><label>Repetition</label></b-input-group-prepend>
                                                <b-form-input v-model="ordLinesObj.repetit_qty" @change="calcPrice()" type="number" ></b-form-input>
                                                <b-form-input v-model="ordLinesObj.repetit_nm" class="ml-1" ></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Amount</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                <span class="input-group-text">{{uanguser}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.budgetamt" :precision="2" disabled></my-number>
                                            </b-input-group>
                                        </b-col>
                                    </b-row >                      
                                </b-col>
                                <b-col md="5">
                                    <b-input-group>
                                        <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                                        <b-form-textarea :rows="5" :max-rows="5" v-model="ordLinesObj.uraian" ></b-form-textarea>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                      <b-row class="justify-content-center mt-1">
                            <div style="width:400px;">
                                <b-input-group >
                                    <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                    <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                    <b-input-group-append>
                                        <b-button class="btn btn-success mr-1" v-if="saveEnabled" @click="saveOrdLines()">Update</b-button>
                                    </b-input-group-append>
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>

                      </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row class="mt-1">
                    <b-col cols="5">
                        <b-row>
                        <b-button size="sm" class="ml-3" v-if="saveEnabled" @click.stop="addOrdLines" >Add Budget Detail</b-button>                          
                            <div class="ml-2">
                                Showing {{((ordLines.page - 1) * ordLines.limit + 1)}}
                                to <span v-if="((ordLines.page * ordLines.limit)>ordLines.total)">{{ordLines.total}}</span>
                                    <span v-else>{{ordLines.page * ordLines.limit}}</span>
                                <strong> of {{ordLines.total}} entries </strong>
                            </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="2">
                            <b-input-group>
                                <b-input-group-prepend><span class="ml-4 pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                                <b-form-select :options="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50]" :plain="true" v-model="ordLines.limit"  style="width:80px;"/>
                            </b-input-group>
                    </b-col>
                    <b-col cols="5">
                        <b-pagination
                            align="right"
                            :total-rows="ordLines.total"
                            :per-page="ordLines.limit"
                            v-model="ordLines.page"
                        ></b-pagination>
                    </b-col>
                </b-row>

              </b-card>    
                <b-row align-h="between" class="mt-1">
                    <b-col md="6" lg="4">
                        <b-input-group >
                            <b-input-group-prepend><span class="pt-2 mr-2">Format Layout</span></b-input-group-prepend>
                            <b-form-select v-model="model.layoutfmt" :plain="true" :options="layouts" ></b-form-select>
                        </b-input-group>
                    </b-col>
                    <b-col md="6" lg="4">
                        <div class="text-right">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total Amount Due</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.budgettotal" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Nett Deal</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.nettdeal" :precision="2"></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Estimate Margin</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.estimatemargin" :precision="2"></my-number>
                            </b-input-group>
                        </div>
                    </b-col>
                </b-row>
            <b-row class="justify-content-center mb-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </b-row>

        </b-card>
        <b-modal v-model="showFormProduksi" size="md" :hide-footer="true" title="Nomor Produksi (Episode/SerialNumber, ..)" :centered="true">                
                    <ul>
                        <li v-for="(nomor,idx) in arrProduksi" :key="`produksi-${idx}`">
                                {{nomor}} 
                        </li>                
                    </ul>
                    <!-- <ul>
                        <li v-for="(nomor,idx) in arrProduksi" :key="`produksi-${idx}`">
                                {{nomor}} <b-link @click="delProduksi(idx)" class="ml-2">  <i class="fa fa-trash"></i></b-link>
                        </li>               
                    </ul>
                    <div style="width:425px; margin-left: 40px;">
                        <b-input-group>
                            <b-input-group-prepend><span class="pt-2">Tambah Nomor </span></b-input-group-prepend>
                            <b-form-input v-model="nomorproduksi" class="ml-1" ></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="addProduksi" >
                                <i class="fa plus-square"></i> Add to list
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                    </div> -->
        </b-modal> 
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Budget Item" :centered="true">
            <lku-item @click="onSelectLkuItem" ></lku-item>
        </b-modal>        
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        
        <b-modal v-model="lkuBudgetShow" size="lg" :hide-footer="true" title="List of Master Budget" :centered="true">
            <lku-budgetproduksi @click="onSelectLkuBudget"></lku-budgetproduksi>
        </b-modal>        

    </div>
</template>
<style lang="scss">
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
        table {
            font-size: smaller;
            th {
                border: 1px solid silver;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border: 1px solid silver;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
        }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 90px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuItem from "../lookup/lkuItembudget";
import lkuCustomer from "../lookup/lkuCustomer";
import lkuBudgetproduksi from "../lookup/lkuBudgetproduksi_all";
import budgetproduksi from "../../apis/budgetproduksi";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber, vDim, lkuCustomer, lkuItem, lkuBudgetproduksi},
  mixins: [validationMixin],
  validations: {
        model: {
            tanggal: { required },
            startdate: { required },
            finishdate: { required },
            uraian: { required },
            cust_id: {required : (function() {
                if (this.model.sales == '0') {
                    return true;
                } else if (!(this.model.cust_id)){
                    return false;
                } else return true;
            })},
            jmlproduksi: { required },
            noawalproduksi: { required },
            nomorproduksi: { required },
        },
        ordLinesObj: {
            jccostkey: { required },
            quantity: { numeric, required },
            unitprice: { numeric, required },
            budgetamt: { numeric, required },
        },
  }, 
  data() {
    return {
        inputBerlanjut: 0,
        inputLineBerlanjut: 1,
        saveEnabled:true,
        lkuCustomerShow:false,
        lkuCoaShow:false,
        lkuItemShow:false,
        lkuBudgetShow:false,
        updateDimHdr:false,
        uanguser: this.$store.state.user.matauang,
        ordLines: {
            page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
            items: [],
            selected:{},
            fields: [
                {key: 'seqNo', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "jccostname",
                    label: "Description",
                },
                {
                    key: "uraian",
                    label: "Note/Remark",
                    thClass: "text-center",
                },
                {
                    key: "unitsize",
                    label: "Unit",
                    thStyle: "width:60px",
                },
                {
                    key: "quantity",
                    label: "Quantity",
                    thStyle: "width:80px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "repetit_qty",
                    label: "Repetition",
                    thStyle: "width:80px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "unitprice",
                    label: "Unit price",
                    thStyle: "width:110px",
                    thClass: "text-center",
                    tdClass: "text-right"
                },
                {
                    key: "budgetamt",
                    label: "Amount",
                    thStyle: "width:110px",
                    thClass: "text-center",
                    tdClass: "text-right"
                },
                {
                    key: "noncash",
                    label: "Non Cash",
                    thStyle: "width:20px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:40px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 15,
            total: 0,
        },
        model: {
            sales: '0',
            tanggal: '',
            startdate: '',
            finishdate: '',
            uraian: '',
            cust_id: '',
            jmlproduksi: 1,
            nomorproduksi: '', noawalproduksi:'',
            nettdeal:0,
            estimatemargin:0,
        },
        ordLinesObj: {
            jccostkey: '',
            quantity: '',
            unitprice: '',
            budgetamt: '',linetype:1, noncash:0,
            jccostcode :'',
            jccostname :'',
            iteminfo:''
        },

        tabIndex:0,
        layouts:[],
        showFormProduksi:false,
        nomorproduksi:'',
        arrProduksi:[]
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidOrdLines() {
      this.$v.ordLinesObj.$touch();
      return this.$v.ordLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    unitprice(){
        return this.ordLinesObj.unitprice;
    },
  },
  watch: {
    unitprice: function(newval) {
        setTimeout(() => {
            this.calcPrice();
        }, 100);
    },    
  },
  created: async function(){
    this.routeAsal = localStorage.getItem('mb-menu') || "budget.mstrbudget";
    this.layouts = await budgetproduksi.layout_combo();
    if (this.$route.params.pjxhdrkey)  {
      toastr.info('Loading Budget Detail, please wait')
      try {
        const data = await budgetproduksi.detail(this.$route.params);  
            const row = data[0];
            this.saveEnabled = (row.send2wf == 1 && row.isreviewed != 1) ? false : true;
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.startdate = row.startdate ? moment(row.startdate).format('YYYY-MM-DD') : '';
            row.finishdate = row.finishdate ? moment(row.finishdate).format('YYYY-MM-DD') : '';
            this.arrProduksi= row.nomorproduksi.split(",");
            row.noawalproduksi = this.arrProduksi[0]; 

            for (var key in row) {
                this.model[key] = row[key];
            }
            this.dimension.forEach((dim) => {
                if (this.model[dim.value]) {
                    this.model[`${dim.value}Info`] = this.model[dim.value] + ' | '+ this.model[`${dim.value}Txt`];
                }
            });
            
            this.ordLines.items = data[1];
            this.ordLines.total = data[1].length;

            // this.calcTotalDtlBudget();
            toastr.clear;
            this.updateDimHdr = !this.updateDimHdr;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
        } else {
            this.model.tanggal  = moment().format('YYYY-MM-DD');
            
            const dim = this.dimension.find(d => d.RelatedObj=='department');
            if (dim) {
                this.model[`${dim.value}`] = this.$store.state.user.departkd;
                this.model[`${dim.value}Txt`] = this.$store.state.user.departemen;
                this.model[`${dim.value}Info`] = this.$store.state.user.departkd + ' | ' + this.$store.state.user.departemen;
            }        
        }
  },
  methods: {
    onSelectLkuBudget: async function (_selected) {
        //    this.model=_selected;
            toastr.info('Loading Master Budget Detail, please wait')
            this.lkuBudgetShow=false;
            const data = await budgetproduksi.detail({pjxhdrkey:_selected.pjxhdrkey});  
            const row = data[0];
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.pjxhdrkey='';
            this.model.nomorcopy=this.model.nomor;
            this.model.nomor='';
            this.model.nomorproduksi='';
            this.arrProduksi= [];
            this.model.noawalproduksi = '';
            this.model.tanggal  = moment().format('YYYY-MM-DD');
            this.model.startdate =  '';
            this.model.finishdate = '';

            this.dimension.forEach((dim) => {
                if (this.model[dim.value]) {
                    this.model[`${dim.value}Info`] = this.model[dim.value] + ' | '+ this.model[`${dim.value}Txt`];
                }
            });
            
            this.ordLines.items = data[1];
            this.ordLines.items.forEach(line=> line.pjxbudgkey='');
            this.ordLines.total = data[1].length;

            this.calcTotalDtlBudget();
            toastr.clear;
            this.updateDimHdr = !this.updateDimHdr;
            console.log('this.ordLines.items : ',this.ordLines.items);
    },

    // addProduksi : function () {
    //     if (this.nomorproduksi) {
    //         const ada =this.arrProduksi.find(nomor =>nomor == this.nomorproduksi);
    //         if (ada){
    //             toastr.error(`Nomor Produksi "${this.nomorproduksi}" sudah ada dalam List`)
    //         } else {
    //             this.arrProduksi.push(this.nomorproduksi);
    //             // const terurut=this.arrProduksi.slice().sort();
    //             // this.model.nomorproduksi= terurut.join(",");
    //             this.model.nomorproduksi= this.arrProduksi.sort().join(",");
    //         }
    //     } else {
    //             toastr.error(`Nomor Produksi belum diisi`)
    //     }

    // },
    // delProduksi : function (index) {
    //     if (index > -1) {
    //         this.arrProduksi.splice(index, 1);
    //     }
    //     this.model.nomorproduksi= this.arrProduksi.join(",");
    // },
    findLastEps: async function(dim) {
        if (this.model[`${dim.value}`]) {
            toastr.info(`Find the Last Production/Eps. Number by ${dim.text}`);
            const hasil = await budgetproduksi.lastEps({DimCol: dim.value, DimColInfo: dim.text, DimVal: this.model[`${dim.value}`] });  
            if (hasil.nomor) {
                this.model.noawalproduksi= parseInt(hasil.nomor);
                console.log('Find the Last Production/Eps. Number ', this.model.noawalproduksi);
                this.$forceUpdate();            
            } else {
                toastr.warn(`Not Found, Last Production/Eps. Number for ${dim.text}`);
            }
        } else {
            toastr.error(`Please select the value for ${dim.text}`);
        }
    },
    produksiChange : function () {
        this.arrProduksi=[];
        const awal=parseInt(this.model.noawalproduksi);
        for (let index = 0; index < this.model.jmlproduksi; index++) {
                this.arrProduksi.push(`${awal+index}`);
        }
        // this.model.nomorproduksi= this.arrProduksi.sort().join(",");
        this.model.nomorproduksi= this.arrProduksi.join(",");
    },
    closeOrdLines: function(){
        const opened= this.ordLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addOrdLines : function () {
        this.closeOrdLines();
        const linetype=this.ordLines.selected ? this.ordLines.selected.linetype : 1;
        const obj={_showDetails:true};
        this.ordLines.selected = obj;
        // for (var key in this.ordLinesObj) {
        //     this.ordLinesObj[key] = '';
        // }
        this.ordLinesObj.linetype=linetype;
        this.ordLinesObj.pjxbudgkey='';
        this.ordLinesObj.jccostkey='';
        this.ordLinesObj.iteminfo = '';
        this.ordLinesObj.jccostcode = '';
        this.ordLinesObj.jccostname = '';
        this.ordLinesObj.uraian='';
        this.ordLinesObj.quantity=0;
        this.ordLinesObj.unitprice=0;
        this.ordLinesObj.budgetamt=0;
        this.inputLineBerlanjut=1;

        // this.ordLinesObj.unitsize='PER DAY';
        obj.seqNo = this.ordLines.items.length +1;
        this.ordLinesObj.quantity = 1;
        this.ordLines.items.push(obj);
        this.ordLines.total=this.ordLines.items.length;
        setTimeout(() => {
            const bfore = this.ordLines.page;
            const after =Math.ceil((this.ordLines.total)/this.ordLines.limit);
            if (bfore != after){
                this.ordLines.page =  after;                 
                toastr.info(`Move to page ${after} of total  ${this.ordLines.total} items`,'Line/Detail',10000);
            }
        }, 100);
        this.inputLineBerlanjut=1;
    },
    editOrdLines : function (obj,callback) {
        this.closeOrdLines();
        this.ordLines.selected = obj;
        // for (var key in this.ordLinesObj) {
        //     this.ordLinesObj[key] = '';
        // }
        this.ordLinesObj.jccostkey='';
        this.ordLinesObj.iteminfo = '';
        this.ordLinesObj.jccostcode = '';
        this.ordLinesObj.jccostname = '';
        this.ordLinesObj.uraian='';
        this.ordLinesObj.quantity=0;
        this.ordLinesObj.unitprice=0;
        this.ordLinesObj.budgetamt=0;
        this.inputLineBerlanjut=0;
        for (var key in obj) {
            this.ordLinesObj[key] = obj[key];
        }
        this.inputLineBerlanjut=0;
        callback();
    },
    delOrdLines: function (index) {
        if (index > -1) {
            // this.ordLines.items.splice(index, 1);
            const posisi = (this.ordLines.page-1)*this.ordLines.limit;
            this.ordLines.items.splice(posisi+index, 1);
        }
        this.ordLines.total=this.ordLines.items.length;
        this.calcTotalDtlBudget();
    },
    saveOrdLines: async function (callback) {
        this.calcPrice();
        if (this.invalidOrdLines) {
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            try {
                    for (var key in this.ordLinesObj) {
                        this.ordLines.selected[key] = this.ordLinesObj[key];
                    }
                    this.ordLines.total=this.ordLines.items.length;
                    this.calcTotalDtlBudget();
                    this.ordLines.selected._showDetails=false;
                    if (callback) callback();
                    if (this.inputLineBerlanjut==1) {
                        this.addOrdLines();
                        this.$v.ordLinesObj.$reset();                        
                    }

            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
        }
    },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;
        if (this.invalidModel) {
            const invalidobj = {};
            for (var key in this.$v.model) {
            if (this.$v.model[key].$anyError) {
                if (this.$v.model[key].$anyError == true) invalidobj[key] = this.$v.model[key];
            }
            }
            console.log('validation model: ', this.model);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;
        } else {
            try {
                this.model.TableName = 'project_budget_header';
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    this.model.pjxhdrkey = this.model.pjxhdrkey || '';
                    this.model.nomor = this.model.nomor || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                    row.startdate = row.startdate ? moment(row.startdate).format('YYYY-MM-DD') : undefined;
                    row.finishdate = row.finishdate ? moment(row.finishdate).format('YYYY-MM-DD') : undefined;
                    let seqNo=1;
                    row.lines = this.ordLines.items.reduce((newArr, item) => {
                        if ((item.jccostkey || '') != '') {
                            item.seqNo = seqNo;
                            newArr.push(item);
                            seqNo += 1;
                        }
                        return newArr;
                    }, []);
                    if (row.lines.length>0) {
                        // await budgetproduksi.save(row);
                        // toastr.success("Complete successfully", "Save Budget");
                        const hasil= await budgetproduksi.save(row);
                        toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save Budget",10000);

                        this.close();
                    } else {
                        toastr.error('Please fill at least 1(one) Budget Detail', 'ERROR MESSAGE');
                        this.saveEnabled=true;
                    }
                } else {
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE");
                    this.saveEnabled=true;
                }

            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.saveEnabled=true;            
            }

        }
    },
    onSelectLkuItem(_selected) {
        if (_selected.judul!='Y') {
        this.ordLinesObj.iteminfo = _selected.jccostcode.trim() + ' | ' + _selected.jccostname.trim();
        this.ordLinesObj.jccostkey = _selected.jccostkey;
        this.ordLinesObj.jccostcode = _selected.jccostcode;
        this.ordLinesObj.jccostname = _selected.jccostname;
        this.ordLinesObj.judul = _selected.judul;
        this.ordLinesObj.level_ = _selected.level_;
        this.lkuItemShow=false;
        } else {
            toastr.error('Judul/Header tidak boleh dipilih sbg detail budget', 'ERROR MESSAGE');
        }
    },
    onSelectLkuCustomer: async function (_selected) {
        this.model.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        this.model.cust_id = _selected.customer_id;
        this.lkuCustomerShow=false;
    },
    calcTotalDtlBudget: function () {
        let ttlamtdue = 0;
        this.ordLines.items.forEach((trx)=> {
                ttlamtdue += (trx.budgetamt || 0);
        });
        this.model.budgettotal = ttlamtdue;
        // this.model.totalpph = totalpph;
    },
    calcPrice : function () {
        this.ordLinesObj.budgetamt = parseFloat(this.ordLinesObj.quantity) * parseFloat(this.ordLinesObj.unitprice) * parseFloat(this.ordLinesObj.repetit_qty || 1);
    },
    updateTgl1: function() {
        var tgl2 = moment(this.model.finishdate, 'YYYY-MM-DD');
        if (!this.model.startdate){
            this.model.startdate=`${tgl2.format('YYYY-MM')}-01`;
            this.tahun=tgl2.format('YYYY');
            this.$forceUpdate();
        } else {
            var tgl1 = moment(this.model.startdate, 'YYYY-MM-DD');
            if (tgl1.format('YYYY') !== tgl2.format('YYYY')){
                this.model.startdate=`${tgl2.format('YYYY')}-01-01`;
                this.tahun=tgl2.format('YYYY');
                this.$forceUpdate();
            }
        }
    },
    updateTgl2: function() {
        var tgl1 = moment(this.model.startdate, 'YYYY-MM-DD');
        if (!this.model.finishdate){
            this.model.finishdate=`${tgl1.format('YYYY')}-12-31`;
            this.tahun=tgl1.format('YYYY');
            this.$forceUpdate();
        } else {
            var tgl2 = moment(this.model.finishdate, 'YYYY-MM-DD');
            if (tgl1.format('YYYY') !== tgl2.format('YYYY')){
                this.model.finishdate=`${tgl1.format('YYYY')}-12-31`;
                this.tahun=tgl1.format('YYYY');
                this.$forceUpdate();
            }
        }
    },
    close(){
      if (this.routeAsal) {
          router.push({name:this.routeAsal});    
      } else {
          router.push({path:"home"});    
      }
    }
  }
};
</script>
